module.exports = __webpack_public_path__ + "img/g1.eeed98d5.jpg";